import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", { class: "mb-3" }, "Login", -1)
const _hoisted_2 = { class: "mb-3" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", {
  for: "email",
  class: "form-label"
}, [
  /*#__PURE__*/_createTextVNode("Email "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-warning" }, "*")
], -1)
const _hoisted_4 = { class: "mb-3" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  for: "password",
  class: "form-label"
}, [
  /*#__PURE__*/_createTextVNode("Password "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-warning" }, "*")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("button", { class: "btn btn-success mt-2 float-end shadow-none" }, "Login", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vee_field = _resolveComponent("vee-field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_vee_form = _resolveComponent("vee-form")!

  return (_openBlock(), _createBlock(_component_vee_form, {
    class: "form__log__in",
    "validation-schema": _ctx.schema,
    onSubmit: _ctx.login
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      (_ctx.log.show_alert)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["alert", _ctx.log.alert_variant]),
            role: "alert"
          }, _toDisplayString(_ctx.log.alert_message), 3))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode(_component_vee_field, {
          type: "Email",
          class: "form-control",
          id: "email",
          name: "email"
        }),
        _createElementVNode("small", null, [
          _createVNode(_component_ErrorMessage, {
            name: "email",
            class: "text-warning d-inline-block mt-2"
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode(_component_vee_field, {
          type: "password",
          class: "form-control",
          id: "password",
          name: "password"
        }),
        _createElementVNode("small", null, [
          _createVNode(_component_ErrorMessage, {
            name: "password",
            class: "text-warning d-inline-block mt-2"
          })
        ])
      ]),
      _hoisted_6
    ]),
    _: 1
  }, 8, ["validation-schema", "onSubmit"]))
}